import { Component, inject, Input } from '@angular/core';

import { getDownloadURL, ref } from 'firebase/storage';

import { FirebaseService } from '../../services/firebase.service';
import { IMAGE_STORAGE_PATH } from '../profile-picture-selector/profile-picture-selector.component';

@Component({
	selector: 'dix-avatar',
	templateUrl: './avatar.component.html',
	styleUrls: ['./avatar.component.scss'],
	standalone: false,
})
export class AvatarComponent {
	private readonly storage = inject(FirebaseService).storage;

	private _identifier: string;

	get identifier() {
		return this._identifier;
	}

	@Input()
	set identifier(value: string) {
		this._identifier = value;
		this.src = null;
		const file = ref(this.storage, `${IMAGE_STORAGE_PATH}/${this.identifier}.png`);
		getDownloadURL(file)
			.then((url) => {
				this.src = url;
			})
			.catch(() => {}); // swallow the error
	}

	@Input() name = '';
	@Input() size: 'small' | 'medium' | 'large' = 'small';

	src: string | null = null;

	get initial(): string {
		return this.name.charAt(0).toUpperCase() || '?';
	}

	onError() {
		this.src = null;
	}
}
